<template>
	<div>
		<SearchComponent v-if='showSearch && loaded' v-click-outside="close" />
	</div>
</template>

<script>
	import SearchComponent from './components/SearchComponent.vue'
	import config from "./config";

	export default {
		name: 'app',
		provide() {
			return {
				theme: this.theme,
				customer_id: this.customer_id
			}
		},
		data() {
			return {
				theme: {
					background_color: "white",
					hl_1: "#735B96",
					hl_2: "#e6e6e6",
					cross_position: "right"
				},
				loaded: false,
				showSearch: false,
				customer_id: config.customer_id ? config.customer_id : '1',

			}
		},
		methods: {
			close(e) {
				this.$nextTick(()=>{
					if(this.canBeClosed){
						hide()
					}
				})
			},
			show() {
				let body = document.getElementsByTagName('body')[0];
				body.classList.toggle("body-overlay");
				this.showSearch = !this.showSearch
				this.canBeClosed = false;
				this._timeout = setTimeout(() => {
					this.canBeClosed = true;
				}, 150)
			},
			hide() {
				let body = document.getElementsByTagName('body')[0];
				body.classList.toggle("body-overlay");
				this.showSearch = !this.showSearch;
			},
			async init(params = {}) {
				this.customer_id = params.customer_id ? params.customer_id : this.customer_id;
				if(params.customer_id){
					await this.get_widget_settings();
					this.loaded = true;
				}
			},
			async get_widget_settings() {
				const url = config.url + '/api/get-widget-settings/' + this.customer_id;
				try {
					const response = await fetch(url);
					const result = await response.json();
					this.theme.background_color = result.backgroundColor;
					this.theme.hl_1 = result.highlightColor1;
					this.theme.hl_2 = result.highlightColor2;
					this.theme.cross_position = result.crossPosition;
				} catch (e) {
					//no widget settings
				}
			}
		},
		components: {SearchComponent},
		created() {
			window.Anysearch = this

		},
		mounted() {
			this.get_widget_settings();
			this.$nextTick(()=>{
				this.loaded = true;
			})
		}
	}
</script>

<style scoped>

	*
	{
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		/*-webkit-font-smoothing: antialiased;*/
		/*-moz-osx-font-smoothing: grayscale;*/
		/*text-align: center;*/
		color: #000000;
	}
</style>

<style lang="scss">

	body
	{
		margin: 0;
		padding: 0;
		overflow-y: scroll;
	}

	.body-overlay{
		overflow: hidden;
		cursor: default;
	}


</style>
